import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Handler} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {isTeamNamespace} from '../../helpers/models/namespaceHelpers';
import {SettingsSidebarInfoBox} from '../common/settingsSidebarInfoBox';

/*
 * Props.
 */

interface SettingsSnoozesSidebarProps {
  namespace: string;
  onCloseClick: Handler;
  onFooterClick: Handler;
}

/*
 * Component.
 */

export const SettingsSnoozesSidebar: FC<SettingsSnoozesSidebarProps> = (props) => {
  if (isTeamNamespace(props.namespace)) {
    return (
      <SettingsSidebarInfoBox
        title={<Trans id="settingssnoozes-infobox-user-title">Custom Snoozes</Trans>}
        body={
          <p>
            <Trans id="settingssnoozes-infobox-admin-body">
              As a team admin, you can configure snooze timings for your teammates. Custom snooze timings
              enable you to choose convenient presets for when you want conversations to reopen in your inbox.
              By snoozing, you can hide a message in your inbox until later or make a sent message reappear
              for follow-up. Customize the settings below so you have preset snooze timings that suit your
              workflow.
            </Trans>
          </p>
        }
        footer={<Trans id="settingstags-infobox-private-footer">Learn more</Trans>}
        onCloseClick={props.onCloseClick}
        onFooterClick={props.onFooterClick}
      />
    );
  }

  return (
    <SettingsSidebarInfoBox
      title={<Trans id="settingssnoozes-infobox-user-title">Custom Snoozes</Trans>}
      body={
        <p>
          <Trans id="settingssnoozes-infobox-user-body">
            Custom snooze timings enable you to choose convenient presets for when you want conversations to
            reopen in your inbox. By snoozing, you can hide a message in your inbox until later or make a sent
            message reappear for follow-up. Customize the settings below so you have preset snooze timings
            that suit your workflow.
          </Trans>
        </p>
      }
      footer={<Trans id="settingstags-infobox-private-footer">Learn more</Trans>}
      onCloseClick={props.onCloseClick}
      onFooterClick={props.onFooterClick}
    />
  );
};
